import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';

@Injectable({
    providedIn: 'root'
})
export class GotlandActions {
    static SET_PERIOD_TICKET_PROGRESS = '[Application]: Set period ticket progress';
    static SET_WALLET_LOADING_PROGRESS = '[Application]: Set wallet loading progress';
    static SET_REGISTRATION_PROGRESS = '[Application]: Set registration progress';
    static SET_RECOVER_PROGRESS = '[Application]: Set recover progress';
    static SET_LOGGED_IN_CUSTOMER = '[Application]: Set logged in customer';
    static CART_PENDING = '[Application]: Cart pending';
    static SET_PAGE_TITLE = '[Application]: Set page title';
    static SET_HIGH_CONTRAST = '[Application] Set high contrast';

    static SET_ASSETS_PATH = '[Application] Set Assets Path';

    static SET_PURCHASE_PROGRESS = '[Application]: Set purchase progress';
    setProgress(payload): RidangoReduxAction {
        return {
            type: GotlandActions.SET_PERIOD_TICKET_PROGRESS,
            payload: payload
        };
    }
    setRegistrationProgress(payload): RidangoReduxAction {
        return {
            type: GotlandActions.SET_REGISTRATION_PROGRESS,
            payload: payload
        };
    }
    setRecoverProgress(payload): RidangoReduxAction {
        return {
            type: GotlandActions.SET_RECOVER_PROGRESS,
            payload: payload
        };
    }
    setWalletLoadingProgress(payload): RidangoReduxAction {
        return {
            type: GotlandActions.SET_WALLET_LOADING_PROGRESS,
            payload: payload
        };
    }
    setLoggedInCustomer(payload): RidangoReduxAction {
        return {
            type: GotlandActions.SET_LOGGED_IN_CUSTOMER,
            payload: payload
        };
    }
    cartPending(payload): RidangoReduxAction {
        return {
            type: GotlandActions.CART_PENDING,
            payload: payload
        };
    }

    setPurchaseProgress(payload): RidangoReduxAction {
        return {
            type: GotlandActions.SET_PURCHASE_PROGRESS,
            payload: payload
        };
    }
    setPageTitle(payload): RidangoReduxAction {
        return {
            type: GotlandActions.SET_PAGE_TITLE,
            payload: payload
        };
    }

    setHighContrastMode(payload): RidangoReduxAction {
        return {
            type: GotlandActions.SET_HIGH_CONTRAST,
            payload: payload
        };
    }

    setAssetsPath(path: string): RidangoReduxAction {
        return {
            type: GotlandActions.SET_ASSETS_PATH,
            payload: path
        };
    }
}
